/* /pricing — plans + subscription calculator (prototype pages3.js pgPricing). Public, no Shell. */
import { useState } from "react";
import { Link } from "react-router-dom";
import type { Cycle } from "../../data/types";
import { useI18n } from "../../i18n";
import { Icon } from "../../ui";
import { AuthTop } from "./components/AuthLayout";
import { PriceCalculator, type CalcValue } from "./components/PriceCalculator";
import { PricingPlans } from "./components/PricingPlans";
import { DEFAULT_PRICES } from "./components/pricingData";
import { useSeo } from "../../seo/useSeo";

export default function Pricing() {
  const { L } = useI18n();
  useSeo("/pricing");
  const [cycle, setCycle] = useState<Cycle>("m");
  const [calc, setCalc] = useState<CalcValue>({ plan: "Business", cycle: "m", seats: 40, ai: false });
  return (
    <div style={{ maxWidth: 1120, marginInline: "auto", padding: "calc(20px + env(safe-area-inset-top, 0px)) 16px 48px" }} data-testid="pricing">
      <AuthTop both />
      <div style={{ textAlign: "center", margin: "40px 0 28px" }}>
        <h1 style={{ fontSize: "clamp(26px, 3vw, 40px)" }}>{L("Simple pricing, per employee", "أسعار بسيطة لكل موظف")}</h1>
        <p className="muted">{L("Every plan includes Arabic & English, Hijri dates and KSA data hosting.", "تشمل كل الباقات العربية والإنجليزية والتاريخ الهجري واستضافة البيانات في المملكة.")}</p>
      </div>
      <PricingPlans prices={DEFAULT_PRICES} cycle={cycle} onCycle={(c) => { setCycle(c); setCalc({ ...calc, cycle: c }); }} />
      <section className="card card-b mt" style={{ marginTop: 28 }}>
        <div className="row between mb">
          <div><h2 style={{ fontSize: 20 }}>{L("Calculate your subscription", "احسب اشتراكك")}</h2><p className="sm muted" style={{ margin: "4px 0 0" }}>{L("The same calculation is used on your tax invoice.", "نفس الحساب المستخدم في فاتورتك الضريبية.")}</p></div>
          <span className="chip gold"><Icon name="sparkle" className="s" />{L("30 days free first", "30 يومًا مجانًا أولًا")}</span>
        </div>
        <PriceCalculator prices={DEFAULT_PRICES} value={calc} onChange={(v) => { setCalc(v); setCycle(v.cycle); }} />
      </section>
      <div className="paynote">
        <Icon name="banknote" />
        <div><b>{L("How payment works", "كيف يتم الدفع")}</b><p>{L("When your trial ends, transfer from your bank app to our Saudi account, upload the receipt in the app, and we activate your plan — usually within one business day. ZATCA tax invoice included.", "عند انتهاء التجربة حوّل من تطبيق البنك وارفع الإيصال في التطبيق، ونفعّل باقتك عادة خلال يوم عمل مع فاتورة ضريبية.")}</p></div>
      </div>
      <div className="row" style={{ justifyContent: "center", marginTop: 28 }}>
        <Link className="btn pri lg" to="/setup" data-testid="pricing-trial"><span>{L("Start your 30-day free trial", "ابدأ تجربة 30 يومًا مجانًا")}</span><Icon name="chevron-right" className="s" /></Link>
        <Link className="btn lg" to="/login"><span>{L("Sign in", "تسجيل الدخول")}</span></Link>
      </div>
    </div>
  );
}
